<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<div class="position_box">
					<h2 class="headline_m type2">
						{{ $t('rtr_business-operation-corps.title1') }}
					</h2>
					<p class="body_m">
						{{ $t('rtr_business-operation-corps.text1') }}<br />
						{{ $t('rtr_business-operation-corps.text2') }}
					</p>
					<div class="button_area">
						<button class="button_bg_red mr_10" @click="toLogin">
							{{ $t('button.signup') }}
						</button>
						<button class="button_bg_black" @click="notYet">
							{{ $t('button.down') }}
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="bottom_area">
			<div class="catch_box">
				<p class="title_l fc_white mb_16">
					{{ $t('rtr_business-operation-corps.title2') }}
				</p>
				<p class="body_m fc_white">
					{{ $t('rtr_business-operation-corps.text3') }}<br />
					{{ $t('rtr_business-operation-corps.text4') }}
				</p>
			</div>
			<div class="bottom_box">
				<h3 class="title_l mb_16 pt_40">
					{{ $t('rtr_business-operation-corps.title3') }}
				</h3>
				<p class="body_m">
					{{ $t('rtr_business-operation-corps.text5') }}<br />
					{{ $t('rtr_business-operation-corps.text6') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';

export default {
	name: 'Corps.m',
	setup() {
		return {};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
<style scoped></style>
